var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileUploader = function SvgFileUploader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#556575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M10 21h4M10 3h4M3 10v4M21 10v4M7 21a4 4 0 0 1-4-4v0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#556575",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M7 21a4 4 0 0 1-4-4v0M17 3a4 4 0 0 1 4 4v0M3 7a4 4 0 0 1 4-4v0M21 17a4 4 0 0 1-4 4v0M9.5 11.5 12 9l2.5 2.5M12 9v6"
  })));
};
export { SvgFileUploader as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiOGVjZDVhYzlmNzdlYjhmZDQ2OTlkZDU5OWNiOTcxMjAuc3ZnIjs=";